import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "selected", "signedId", "destroyField", "kept"]

  connect() {
    // console.log("!!! upload file connect", this.inputTarget.files)
    // this.preventDefault = this.preventDefault.bind(this);
    // this.input.addEventListener("drop", this.preventDefault, false)
    if (this.hasSignedIdTarget && this.signedIdTarget.value) {
      this.element.classList.add("files-selected")
    }
  }

  // preventDefault(e) {
  //   e.preventDefault()
  //   e.stopPropagation()
  // }

  // drop(e) {
  //   console.log("drop")
  //   const files = e.dataTransfer.files
  //   this.handleFiles(files)
  // }

  triggerFileInput() {
    // console.log("!!! upload file triggerFileInput")
    this.inputTarget.click()
  }

  handleFiles(event) {
    // console.log("!!! upload file handleFiles", event) 
    const files = event.target?.files || event
    const fileNames = Array.from(files).map(file => file.name).join(", ")
    this.selectedTarget.textContent = `${fileNames}`
    this.element.classList.add("files-selected")
  }

  removeFile() {
    // console.log("!!! upload file removeFile")
    this.inputTarget.value = ""
    this.selectedTarget.textContent = ""
    this.element.classList.remove("files-selected")
    // files kept from a rejected submit go too, or they'd be resent with the next attempt
    this.keptTargets.forEach((kept) => kept.remove())
    
    // If there's a destroy checkbox for nested attributes, check it
    // This is used when removing already-persisted files
    const destroyCheckbox = this.element.querySelector('input[name*="[_destroy]"]')
    if (destroyCheckbox) {
      destroyCheckbox.checked = true
    }
  }

  removePart() {
    // Mark the part for destruction
    if (this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.value = '1'
    }
    
    // Hide the entire part container (controller is attached to the container)
    this.element.style.display = 'none'
  }

  disconnect() {
    // this.dropZoneTarget.removeEventListener("drop", this.preventDefault, false)
  }
} 